import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Loader, Icon, Button } from "semantic-ui-react";
import api from "../../../api";

const INTERVALO_MS = 8000;
const CONFIRMADO = "CO";
const CANCELADO = "CA";
// o Nitrus só permite exibir a página em iframe depois de autorizar o domínio (frame-ancestors);
// com REACT_APP_NITRUS_EMBED=true a página aparece dentro do checkout, senão abre em nova aba
const EMBUTIR = process.env.REACT_APP_NITRUS_EMBED === "true";

// O Nitrus bloqueia exibição em iframe (X-Frame-Options: DENY): a página de pagamento abre em nova aba
// e esta tela acompanha o status da cobrança para liberar a compra assim que o pagamento for confirmado.
const PagamentoNitrusFrame = ({ pagamento, onStatus }) => {
  const url = pagamento && pagamento.urlPagamento;
  const hash = pagamento && pagamento.hash;
  const onStatusRef = useRef(onStatus);
  onStatusRef.current = onStatus;
  const [copiado, setCopiado] = useState(false);

  const copiar = () => {
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => setCopiado(true));
  };

  useEffect(() => {
    if (!hash) return undefined;
    let ativo = true;

    const verificar = async () => {
      try {
        const atualizado = await api.pagamento.updateStatus(hash);
        if (!ativo) return;
        if (atualizado.status === CONFIRMADO || atualizado.status === CANCELADO) {
          onStatusRef.current(atualizado);
          return;
        }
      } catch (e) {
        // pagamento deixou de estar pendente ou erro temporário: tenta de novo / encerra
        if (e && e.status === 400) return;
      }
      if (ativo) timer = setTimeout(verificar, INTERVALO_MS);
    };

    let timer = setTimeout(verificar, INTERVALO_MS);
    return () => {
      ativo = false;
      clearTimeout(timer);
    };
  }, [hash]);

  if (!url) {
    return <Loader inline="centered" active size="medium">Gerando pagamento...</Loader>;
  }

  return (
    <div className="va-nitrus-aguardo">
      {EMBUTIR ? (
        <iframe
          title="Pagamento Nitrus"
          src={url}
          style={{ width: "100%", height: 760, border: "1px solid #e6e9f0", borderRadius: 12, background: "#fff", marginBottom: 14 }}
          sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          allow="payment; clipboard-write"
        />
      ) : (
        <>
          <Icon name="qrcode" size="big" />
          <h4>Cobrança gerada</h4>
          <p>
            Abra a página segura do Nitrus para pagar com PIX ou boleto. Esta tela acompanha o pagamento
            e libera a compra sozinha assim que ele for confirmado.
          </p>
        </>
      )}
      <Button as="a" href={url} target="_blank" rel="noopener noreferrer" className="btn-ui-1" size="large">
        <Icon name="external alternate" /> {EMBUTIR ? "Abrir em nova aba" : "Abrir página de pagamento"}
      </Button>
      <div className="va-nitrus-copiar">
        <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
        <Button size="mini" basic onClick={copiar}>{copiado ? "Copiado!" : "Copiar link"}</Button>
      </div>
      <div className="va-nitrus-status"><Loader inline active size="mini" /> Aguardando confirmação do pagamento...</div>
    </div>
  );
};

PagamentoNitrusFrame.propTypes = {
  pagamento: PropTypes.shape({ urlPagamento: PropTypes.string, hash: PropTypes.string }),
  onStatus: PropTypes.func.isRequired
};

export default PagamentoNitrusFrame;
